<template>
  <component
    :is="component"
    v-bind="defaultAttributes"
    class="panel-dropdown-menu-item block w-full truncate whitespace-nowrap text-start focus:outline-none"
    :class="{
      'panel-dropdown-menu-item--sm': size === 'small',
      'panel-dropdown-menu-item--lg': size === 'large',
      'panel-dropdown-menu-item--disabled': disabled,
    }"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    as: {
      type: String,
      default: 'external',
      validator: v => ['button', 'external', 'form-button', 'link'].includes(v),
    },
    disabled: { type: Boolean, default: false },
    size: {
      type: String,
      default: 'small',
      validator: v => ['small', 'large'].includes(v),
    },
  },

  computed: {
    component() {
      return {
        button: 'button',
        external: 'a',
        link: 'Link',
        'form-button': 'FormButton',
      }[this.as]
    },

    defaultAttributes() {
      return {
        ...this.$attrs,
        ...{
          disabled:
            this.as === 'button' && this.disabled === true ? true : null,
          type: this.as === 'button' ? 'button' : null,
        },
      }
    },
  },
}
</script>
